import {
  // Avatar, Button,
  Card, CardContent, CardActions, Typography,
  // Stack, Chip, Grid, CardMedia,
  Box, styled, Link
} from '@mui/material';
// import Link from 'next/link';
// import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
// import { readingTime } from '../../utils/helpers';
// import { getRandomStr } from '../../../helpers';
import { useRouter } from 'next/router';
import Image from 'next/image';

const StyledCard = styled(Card)`
  cursor: pointer;
  overflow: hidden;
  margin: 0 0 12px 0;
  &:last-child {  margin: 0; }
  img { transition: transform 300ms ease-in-out; background: linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.9)); }
  &:hover img { transform: scale(1.02); }`;

export default function Idea({ post, index, spaceEvenly }) {

  const router = useRouter()
  const convertTime12to24 = time12h => {
    const [time, modifier] = time12h?.split(' ');
    let [hours, minutes, seconds] = time ? time.split(':') : null;
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  };

  const getDate = (date) => {
    let d = new Date(date);
    let n = d.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
    let t = d.toLocaleTimeString('en-US', { timeZone: "America/New_York" })
    let replase = n?.replace(new RegExp(',', 'g'), ' ')
    return `${replase} • ${convertTime12to24(t)}`
  }

  return (
    <Link underline="none" href={`/stock-ideas/${post.slug}`}
      sx={{
        '&:hover .idea-title': {
          color: '#174ea6'
        }
      }}
    >
      <StyledCard key={index} className={post?.frontmatter?.tags?.find(d => d === 'premium') ? 'premium-blog' : 'blog'}
        // onClick={() => router.push(`/stock-ideas/${post.slug}`)}
        sx={{
          // maxWidth: 650,

          // '&:hover': { background: 'fbfbfc', boxShadow: '0 3px 5px rgba(132,135,154,.2), 0 1px 1px rgba(132,135,154,.2)' },
          border: '1px solid #eae9ee',
          cursor: 'pointer', p: '12pxx', borderRadius: '8px', boxShadow: 0, display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
          // bgcolor: (post?.frontmatter?.tags?.find(d => d === 'premium') || (index === 0 || index === 1)) ? '#f8f9fa' : 'transparent'
          display: 'flex', flexDirection: 'row', overflow: 'hidden', width: '100%'
        }}>
        <Box component="div" className="cover-image" sx={{ borderRight: '1px solid #eae9ee', bgcolor: '#f8f9fa', display: 'block', width: { md: '35%', sm: '40%', xs: '30%' }, '& span': { height: '100% !important' } }}>
          {post?.frontmatter?.cover_image &&
            <Image
              src={post?.frontmatter?.cover_image}
              alt={post?.frontmatter?.title}
              layout="responsive"
              objectFit="cover"
              quality={47}
              height={57}
              width={100}
              blurDataURL="URL"
              placeholder="blur"
            />}
        </Box>
        <CardContent sx={{ px: { xs: 2, md: '18px', sm: '18px' }, pt: '12px', pb: '0px !important', width: { md: '65%', sm: '60%', xs: '70%' } }}>
          {/* <Stack direction="row" spacing={1}>
          {post?.frontmatter?.tags?.map(d =>
            d && d === 'premium' ?
              <Chip key={getRandomStr(3)} label={d} size="small" sx={{ background: 'linear-gradient(to right, #2DA1EE, #174ea6)', color: '#fff', textTransform: 'capitalize' }} /> :
              <Chip key={getRandomStr(3)} label={d.replace(/-/g, " ")} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', textTransform: 'capitalize' }} />)}
          {(index == 0 || index == 1) && !post?.frontmatter?.tags?.find(d => d === 'latest') && <Chip label={`Latest`} size="small" sx={{ background: '#E7EBF0', color: '#3E5060', }} />}
        </Stack> */}
          <Box component="div" sx={{ mx: 0, mt: { md: .5, sm: 0, xs: 0 } }}>
            <CardActions sx={{ p: 0 }}>
              <Typography variant="caption" sx={{ fontSize: '.8rem', }} color="#6e6e73">
                {getDate(post?.frontmatter?.date)}
              </Typography>
              {/* <Button href={`/stock-ideas/${post.slug}`} size="small" endIcon={<KeyboardArrowRightRoundedIcon fontSize="small" />} sx={{ textTransform: 'none', ml: 'auto', fontSize: '.8rem', fontWeight: 600 }}>Read more</Button> */}
            </CardActions>
          </Box>
          <div style={{ position: 'relative' }}>
            <Typography variant="h6" component="div"
              className="idea-title"
              sx={{
                fontWeight: 600, fontSize: { md: '1.2rem', sm: '1.2rem', xs: '.9rem' }, '& a': {
                  color: '#1d1d1f',
                  textDecoration: 'none'
                }, '& a:hover': { color: '#174ea6', textDecoration: 'underline' }, lineHeight: 1.2, mt: 1, mb: 1.7
              }}>
              {/* <Link href={`/stock-ideas/${post.slug}`}> */}
              {post?.frontmatter?.title}
              {/* </Link> */}
            </Typography>
            <Typography variant="body1"
              sx={{
                fontSize: '.87rem', display: '-webkit-box', mb: 1,
                WebkitLineClamp: { md: 2, sm: 1, xs: 1 }, WebkitBoxOrient: 'vertical', overflow: 'hidden', textOverflow: 'ellipsis',
              }}
              color="#6e6e73"  // color="text.secondary"
            >
              {post?.frontmatter?.description}
            </Typography>
            <Typography variant="body1" sx={{
              fontSize: '.84rem', position: 'absolute',
              bottom: 0, right: 0, background: '#fff', '& ._': { color: '#6e6e73', textDecoration: 'underline' }, '&:hover ._': { color: '#174ea6', },
              '..': { color: '#6e6e73', textDecoration: 'underline' }
            }}
            >
              <span className=".">{`... `}</span><span className="_">{`Read more`}</span>
            </Typography>
          </div>
        </CardContent>
      </StyledCard>
    </Link>
  )
}
